import { render } from "./email-page.vue?vue&type=template&id=1a1be78e&scoped=true"
import script from "./email-page.vue?vue&type=script&lang=js"
export * from "./email-page.vue?vue&type=script&lang=js"

import "./email-page.vue?vue&type=style&index=0&id=1a1be78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1be78e"]])

export default __exports__